/* eslint-disable prettier/prettier */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import Axios from 'assets/remote/axios';
import {
    GET_BENEFACTORS,
    GET_MY_BENEFACTORS,
    CREATE_BENEFACTOR,
} from '../actions';
import {
    benefactors,
    myBenefactors,
    benefactorError,
    benefactorSuccess,
} from './actions';
import { delay } from 'helpers/Utils';
import { NotificationManager } from 'components/common/react-notifications';


function* errorHandler(error) {
    try {
        if ('response' in error) {
            const keys = Object.keys(error?.response?.data?.errors);
            // eslint-disable-next-line no-restricted-syntax
            for (const item of keys) {
                (NotificationManager.error(error?.response?.data?.errors[item][0], 'خطای عملیات', 3000, null, null, ''));
                yield put(benefactorError(error?.response?.data?.errors[item][0]));
            }
            // yield put(benefactorError(''));
        } else {
            (NotificationManager.error(error?.message, 'خطای عملیات', 3000, null, null, ''));
            yield put(benefactorError(error?.message));
        }
    } catch (e) {
        (NotificationManager.error(error?.message, 'خطای انجام فرآیند', 3000, null, null, ''));
        yield put(benefactorError('خطا انجام فرآیند'));
    }
}


export function* watchGetMyBenefactors() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(GET_MY_BENEFACTORS, getMyBenefactors);
}
const getMyBenefactorsAsync = async (filter) => {
    const r = await Axios.get('/benefactors', filter);
    return r?.data;
}
function* getMyBenefactors({ payload }) {
    // const { filter } = payload;
    try {
        const response = yield call(getMyBenefactorsAsync, payload);
        yield put(myBenefactors(response));
        yield put(benefactorSuccess('لیست با موفقیت دریافت شد'));
        yield put(benefactorSuccess(''));
    } catch (error) {
        yield call(errorHandler, error);
    }
}

export function* watchGetBenefactors() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(GET_BENEFACTORS, getBenefactors);
}
const getBenefactorsAsync = async (filter) => {
    const r = await Axios.get('/benefactor/admin/index', filter);
    return r?.data;
}
function* getBenefactors({ payload }) {
    // const { filter } = payload;
    try {
        const response = yield call(getBenefactorsAsync, payload);
        yield put(benefactors(response));
        yield put(benefactorSuccess('لیست با موفقیت دریافت شد'));
        yield put(benefactorSuccess(''));
    } catch (error) {
        yield call(errorHandler, error);
    }
}

export function* watchCreateBenefactor() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(CREATE_BENEFACTOR, createBenefactor);
}

const createBenefactorAsync = async (payload) => {
    const response = await Axios.post('benefactors', payload)
    return response?.data;
};

function* createBenefactor({ payload }) {
    try {
        const result = yield call(createBenefactorAsync, payload.benefactor)
        yield call(getMyBenefactors, { payload: {} });
        yield put(benefactorSuccess(result?.message));
        yield call(payload?.callback);
        // yield put(benefactorSuccess(''));
    } catch (error) {
        yield call(errorHandler, error);
    }
}

// const createBenefactorAsync = async (id, key, value) => {
//     const response = await Axios.put(`/settings/${id}`, { key, value })
//     return response?.data;
// };

export default function* rootSaga() {
    yield all([
        fork(watchGetBenefactors),
        fork(watchGetMyBenefactors),
        fork(watchCreateBenefactor),
    ]);
}
